/**
 * The approver's rate (DESIGN-toil.md E, E1, E2): four choices, the company's usual one
 * already ticked, the time given back shown live. "Enter it" is how the approver changes
 * the amount (B). Every button is type="button" — this sits inside other people's dialogs
 * (CONVENTIONS.md, "never nest a form").
 */
import React from 'react';
import { RATE_OPTIONS, fmtToil, givenMinutes } from '../../lib/toil';

export default function RatePicker({ worked, rate, onRate, customH, customM, onCustom, usual, compact }) {
  return (
    <div>
      <div className={`grid gap-2 ${compact ? 'grid-cols-4' : 'grid-cols-2 sm:grid-cols-4'}`} data-testid="toil-rate-picker">
        {RATE_OPTIONS.map((o) => {
          const on = rate === o.value;
          const given = o.value === 'custom' ? null : givenMinutes(worked, o.value);
          return (
            <button
              key={o.value}
              type="button"
              onClick={() => onRate(o.value)}
              data-testid={`toil-rate-${o.value}`}
              className={`rounded-xl border px-2 py-2 text-center transition-colors ${
                on ? 'border-primary bg-primary/10' : 'border-border bg-secondary/30 hover:bg-secondary/60'}`}
            >
              <span className="block text-xs font-semibold">{o.label}</span>
              <span className="block text-[11px] text-muted-foreground">
                {o.short}{usual === o.value ? ' · usual' : ''}{o.value === 'custom' ? ' ' : ''}
              </span>
              {o.value !== 'custom' ? (
                <span className="block font-heading font-bold text-base">{given != null ? fmtToil(given) : '—'}</span>
              ) : (
                <span className="block text-xs text-muted-foreground mt-1">type it below</span>
              )}
            </button>
          );
        })}
      </div>
      {rate === 'custom' && (
        <div className="flex items-center gap-2 mt-2">
          <input
            type="number" min="0" max="48" inputMode="numeric" value={customH}
            onChange={(e) => onCustom(e.target.value, customM)}
            className="input-hive w-20 rounded-md border border-input bg-background px-2 py-1.5 text-sm"
            aria-label="Hours given back" data-testid="toil-custom-hours"
          />
          <span className="text-sm text-muted-foreground">hours</span>
          <input
            type="number" min="0" max="59" step="5" inputMode="numeric" value={customM}
            onChange={(e) => onCustom(customH, e.target.value)}
            className="input-hive w-20 rounded-md border border-input bg-background px-2 py-1.5 text-sm"
            aria-label="Minutes given back" data-testid="toil-custom-minutes"
          />
          <span className="text-sm text-muted-foreground">minutes given back</span>
        </div>
      )}
    </div>
  );
}
